import axiosInstance from '../helpers/axiosInstance';

export const getBillOfQuantityApi = async (item) => {
    const url = `staff/billOfQuantity?${item}`;
    const response = await axiosInstance.get(url);
    return response.data;
};

export const getPoUnconvertedListApi = async (item) => {
    const url = `staff/billOfQuantity/unconvertedBoqToPO?${item}`;
    const response = await axiosInstance.get(url);
    return response.data;
};

export const getBillOfQuantityCsvApi = async (item) => {
    const url = `staff/billOfQuantity/csv?${item}`;
    const response = await axiosInstance.get(url, { responseType: 'text' });
    return response.data;
};

export const createBoqApi = async (request) => {
    const response = await axiosInstance.post('staff/billOfQuantity', request.formData);
    return response.data;
};

export const getConfirmQuotDropdownApi = async () => {
    const response = await axiosInstance.get('staff/dropdown/confirmedQuotation');
    return response.data;
};

export const getConfirmQuotDropdownApiV2 = async (groupName) => {
    const response = await axiosInstance.get(`staff/dropdown/confirmedQuotation/v2?groupName=${groupName}`);
    return response.data;
};

export const getConfirmQuotProductsApi = async (quotationId) => {
    const response = await axiosInstance.get(`staff/confirmedQuotationProducts/${quotationId}`);
    return response.data;
};

export const getConvertBoqToPoList = async () => {
    const response = await axiosInstance.get('staff/listOfBoqForConvertToPo');
    return response.data;
};

export const createBillOfQuantityApi = async (request) => {
    const response = await axiosInstance.post('staff/billOfQuantity/createBillOfQuantity', request.formData);
    return response.data;
};

export const getOneBillOfQuantityApi = async (id) => {
    const response = await axiosInstance.get(`staff/purchaseOrder/${id}`);
    return response.data;
};

export const updateBillOfQuantityPoApi = async (request) => {
    const response = await axiosInstance.put('staff/billOfQuantity', request.formData);
    return response.data;
};

export const csvBoqDownloadApi = async (request) => {
    const response = await axiosInstance.get(`staff/billOfQuantity/${request.formData.id}/csv`, { responseType: 'text' });
    return response.data;
};

export const getBoqProjectDetailApi = async (id) => {
    const response = await axiosInstance.get(`staff/billOfQuantity/${id}/projectsProductDetail`);
    return response.data;
};

export const createBoqProjectApi = async (request) => {
    const response = await axiosInstance.post('staff/billOfQuantityProject', request.formData);
    return response.data;
};

export const updateBoqProjectApi = async (request) => {
    const response = await axiosInstance.put('staff/billOfQuantityProject', request.formData);
    return response.data;
};

export const createBoqProductApi = async (request) => {
    const response = await axiosInstance.post('staff/billOfQuantityProduct', request.formData);
    return response.data;
};

export const updateBoqProductApi = async (request) => {
    const response = await axiosInstance.put('staff/billOfQuantityProduct', request.formData);
    return response.data;
};

export const deleteBoqProductApi = async (id) => {
    const response = await axiosInstance.delete(`staff/billOfQuantityProduct/${id}`);
    return response.data;
};

export const previewBoqApi = async (id) => {
    const response = await axiosInstance.get(`public/billOfQuantity/${id}/html`, { responseType: 'text' });
    return response.data;
};

export const getBoqByIdApi = async (id) => {
    const response = await axiosInstance.get(`staff/billOfQuantity/${id}`);
    return response.data;
};

export const generateBoqApi = async (id) => {
    const response = await axiosInstance.get(`staff/billOfQuantity/${id}/generate`);
    return response.data;
};

export const sendBoqApi = async (id) => {
    const response = await axiosInstance.put(`staff/billOfQuantity/${id}/markSent`);
    return response.data;
};

export const cloneBoqApi = async (id) => {
    const response = await axiosInstance.post(`staff/billOfQuantity/${id}/clone`);
    return response.data;
};

export const deleteBoqApi = async (id) => {
    const response = await axiosInstance.delete(`staff/billOfQuantity/${id}`);
    return response.data;
};

export const reviseBoqApi = async (id) => {
    const response = await axiosInstance.post(`staff/billOfQuantity/${id}/clone?revised=true`);
    return response.data;
};

export const editBoqCustomProductApi = async (request) => {
    const response = await axiosInstance.put('staff/billOfQuantityProduct/editCustomProduct', request.formData);
    return response.data;
};

export const getProjectOutwardListApi = async (searchParams = "") => {
    const url = searchParams ? `staff/listOfProjectsForOutwards?${searchParams}` : 'staff/listOfProjectsForOutwards';
    const response = await axiosInstance.get(url);
    return response.data;
};

export const getProjectOutwardListV2Api = async (request) => {
    const response = await axiosInstance.get(`staff/ProductsForOutwards/${request.boqId}`);
    return response.data;
};

export const getInternalTransferProductApi = async (id) => {
    const response = await axiosInstance.get(`staff/billOfQuantity/${id}/internalTransfer/productDetails`);
    return response.data;
};

export const deliverBoqApi = async (request) => {
    const response = await axiosInstance.put('staff/billOfQuantity/deliver', request.formData);
    return response.data;
};

export const updateInternalTransferApi = async (request) => {
    const response = await axiosInstance.put('staff/billOfQuantity/internalTransfer', request.formData);
    return response.data;
};

export const previewPackingSlipApi = async (id) => {
    const response = await axiosInstance.get(`public/packingSlip/${id}/html`, { responseType: 'text' });
    return response.data;
};

export const getBoqProductDetailsApi = async (id) => {
    const response = await axiosInstance.get(`staff/outward/packingSlip/${id}`);
    return response.data;
};

export const getBoqMailDetailsApi = async (id) => {
    const response = await axiosInstance.get(`staff/billOfQuantity/sendMail/${id}`);
    return response.data;
};

export const sendBoqMailApi = async (request) => {
    const response = await axiosInstance.post('staff/billOfQuantity/sendMail', request.formData);
    return response.data;
};

export const getSentBoqProductListApi = async (boqId) => {
    const response = await axiosInstance.get(`staff/billOfQuantity/getSentBoqProductList/${boqId}`);
    return response.data;
};
